import { api } from '../configs/axiosConfigs';

export const getFinalDecisionMakingProperties = async (listSortId: string) => {
  return await api.get(`/final-decision-making/${listSortId}/properties`);
};
